import Vuex from 'vuex'
import products from './products'
export default new Vuex.Store({
    modules: {
        products,
    }
})